
<div>
    <app-reason-master-form></app-reason-master-form>
</div>
<div>
    <app-reason-master-list></app-reason-master-list>
</div>
